module.exports = __webpack_public_path__ + "static/img/revoke.5c103c31.png";